import { Component, ViewChild } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { DataServiceService } from '../../services/data-service.service';
import { DxDataGridComponent, DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid as exportDataGridToExcel } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
import { jsPDF } from 'jspdf';
import { MerchantService } from '../../services/merchantservice';
import { merchantCardSummayDetail } from '../../components/utils/models/merchantCardSummaryDetail';
import { EnvironmentService } from '../../services/environment.service';
import { DataCardInterface } from '../../components/utils/models/data-card-interface';
import { HttpClient } from '@angular/common/http';
import ODataStore from 'devextreme/data/odata/store';

@Component({
  selector: 'app-merchant',
  templateUrl: './merchant.component.html',
  styleUrl: './merchant.component.scss',
  providers : [MerchantService]
  
})
export class MerchantComponent {
  merchantsDataSource: DataSource;
  isContentScrolled = false;
  cardDataValues: DataCardInterface[] = []
  titleIcons = { // TODO: need to find a better way to do this
    'Active Merchants': 'heroBriefcase',
    'Merchant Accounts Balance': 'heroBanknotes', 
    'Wallets Balance': 'heroBanknotes', 
    'Active Cards': 'heroCreditCard', 
    'Cards Balance': 'heroBanknotes'
  }
  defaultValues : any[]  = [
    { title : 'Active Merchants', value : 0 , valueType : "number"},
    { title : 'Merchant Accounts Balance', value : 0, valueType : "currency"},
    { title : 'Wallets Balance', value : 0, valueType : "number"},
    { title : 'Active Cards', value : 0 , valueType : "number"  },
    { title : 'Cards Balance', value : 0 ,valueType : "currency"}
  ];
  summary: any;
  totalRecords: number = 0;
  currentPageCount : number = 0;

  @ViewChild(DxDataGridComponent, { static : false}) dataGrid!: DxDataGridComponent

  constructor(private dataService : DataServiceService, private merchservice : MerchantService, private environmentService: EnvironmentService, private httpClient: HttpClient)
  {
    this.merchantsDataSource = this.dataService.getMerchantsDataSource();
  }

  scroll({reachedTop = false}) {
    this.isContentScrolled = !reachedTop;
  }

  ngOnInit() {

    this.merchservice.getCardValues()
    .subscribe(
      (data: merchantCardSummayDetail[]) => {
        const elementsNotInDataValues = this.defaultValues.filter(
          item => !data.some(dbresItem => dbresItem['title'] === item['title'])
        );
        data.map(d => this.cardDataValues.push({
          titleText: d.title,
          value: d.value,
          type: d.valueType,
          icon: this.titleIcons[d.title] ? this.titleIcons[d.title] : 'card'
        }));
      },
      (error: any) => {
        console.error('Error fetching card values', error);
      }
    );
    

  }

  isValidDateUsingParse(dateString: string): boolean {
    const timestamp = Date.parse(dateString);
    return !isNaN(timestamp); // Check if timestamp is valid
  }

  customCurrencyFormat = {
    formatter: (value) => {
      // Define the currency formatter
      const currencyFormatter = new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      // Format the value
      let formattedValue = currencyFormatter.format(value);
      return formattedValue;
    }
  };

  onExporting(e: any) {
    if (e.format === 'xlsx') {
      this.exportToExcel(e);
    } else if (e.format === 'pdf') {
      this.exportToPDF(e);
    }
  }

  exportToExcel(e: DxDataGridTypes.ExportingEvent) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('FinanceMerchants');
    
    exportDataGridToExcel({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        const now =  new Date();
        const TodaysDate = this.formatDate(now)
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `FinanceMerchants_${TodaysDate}.xlsx`);
      });
    });
  }

  async exportToPDF(e: any) {
    const doc = new jsPDF('landscape');
    const pngBase64 = await this.convertPngToBase64('assets/icons/bitventurelogo.png');
    
    // Get the page width and height
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    
    // Define the image width and height
    const imageWidth = 20;  // Adjust width
    const imageHeight = 5;  // Adjust height
    
    // Define margins
    const marginRight = 10; // Margin from the right edge
    const marginTop = 10;   // Margin from the top edge
    const marginBelow = 20; // Margin below the image

    // Calculate the x and y coordinates for the image
    const x = pageWidth - imageWidth - marginRight;
    const y = marginTop;
    
    // Add PNG image to PDF
    doc.addImage(pngBase64, 'PNG', x, y, imageWidth, imageHeight);
    
    // Set the y coordinate for the grid data, starting below the image
    const gridY = y + imageHeight + marginBelow;
    
    // Export DataGrid to PDF
    await exportDataGridToPDF({
      jsPDFDocument: doc,
      component: e.component,
      margin: { top: gridY , left : 2, right : 2 } // Start the grid data export below the image
    });
    
    // Save the PDF
    const now = new Date();
    const todaysDate = this.formatDate(now);
    doc.save(`FinanceMerchants_${todaysDate}.pdf`);
    e.cancel = true;
  }

  async convertPngToBase64(pngFilePath: string): Promise<string> {
    const response = await fetch(pngFilePath);
    const blob = await response.blob();
    const reader = new FileReader();
    return new Promise<string>((resolve, reject) => {
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

   formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}/${month}/${day}, ${hours}:${minutes}:${seconds}`;
  }

  onCellPrepared (e) {
    if (e.rowType === "data") {
        // console.log(e);
        if (e.column.dataField === "AccountBalance" && e.data.AccountBalance <= e.data.MinAccountBalance) {
          e.cellElement.style.cssText = "color: red;font-weight:bold;text-align:right;";
        }

        if (e.column.dataField === "WalletsBalance" && e.data.WalletsBalance <= e.data.WalletsMinBalance) {
          e.cellElement.style.cssText = "color: red;font-weight:bold;text-align:right;";
        }
    }
  }

  ngAfterViewInit() {
    this.refreshDataGrid();
  }

  refreshDataGrid() {
    this.merchantsDataSource.load(); 
  }

}
